import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero, Section, PrimaryButton } from "@/components/ui-helpers";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then(({ data }) => setFaqs(data)).catch(() => {}); }, []);
  const cats = [...new Set(faqs.map((f) => f.category))];
  const faqJsonLd = faqs.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }
    : null;
  return (
    <>
      <SEO title="FAQ" description="Answers to common questions about Ascendia's cleaning and detailing services, pricing, scope and logistics." jsonLd={faqJsonLd} />
      <PageHero kicker="FAQ" title="Questions, answered" subtitle="Everything you need to know about our services, pricing and process.">
        <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
      </PageHero>
      <Section>
        <div className="space-y-12">
          {cats.map((cat) => (
            <div key={cat}>
              <p className="kicker mb-4">{cat}</p>
              <Accordion type="single" collapsible className="space-y-3">
                {faqs.filter((f) => f.category === cat).map((f) => (
                  <AccordionItem key={f.id} value={f.id} className="ascendia-card border-0 px-5">
                    <AccordionTrigger className="text-left text-white hover:no-underline py-4">{f.q}</AccordionTrigger>
                    <AccordionContent className="text-secondary pb-4">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
